// CommonDropdown.js
import React from 'react';


const CommonDropdown = ({ options, value, onChange, placeholder }) => {
  return (
    <div className="main-dropdown-container">
      <select
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="dropdown-bar" // Styling for dropdown
      >
        <option value="">{placeholder || '--Select--'}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CommonDropdown;
